import { Component, Input, OnInit } from '@angular/core';
import { FormControl, FormGroup } from '@angular/forms';
import { ModalController } from '@ionic/angular';
import { SelectOption } from '@shared/models/select-option';

@Component({
  selector: 'app-multi-select',
  templateUrl: './multi-select.component.html',
  styleUrls: ['./multi-select.component.scss'],
  standalone: false,
})
export class MultiSelectComponent implements OnInit {
  @Input() type: string;
  @Input() title: string;
  @Input() selectOptions: SelectOption[];
  @Input() selectedOptions: SelectOption[] = [];
  @Input() selectLimit: number;
  multiSelectSearchForm: FormGroup;
  selectedList: SelectOption[] = [];
  unselectedList: SelectOption[] = [];

  constructor(private modalController: ModalController) {}

  ngOnInit(): void {
    this.multiSelectSearchForm = new FormGroup({
      multiSelectSearchInput: new FormControl(''),
    });
    this.selectedList = [...this.selectedOptions];
    this.unselectedList = this.selectOptions.filter(
      (option) => !this.selectedList.some((selectedOption) => selectedOption.value == option.value),
    );
  }

  handleSelectionChange(event: any, option: SelectOption) {
    if (event.detail.checked) {
      if (!!this.selectLimit && this.selectedList.length < this.selectLimit) {
        this.selectedList.push(option);
      } else if (!this.selectLimit) {
        this.selectedList.push(option);
      }
    } else {
      this.selectedList = this.selectedList.filter((selectedOption) => selectedOption.value !== option.value);
    }
    this.filterOptions();
  }

  filterOptions() {
    const searchValue = this.multiSelectSearchForm.get('multiSelectSearchInput')!.value;
    this.unselectedList = this.selectOptions.filter((option) => {
      return (
        option.title.toLowerCase().includes(searchValue.toLowerCase()) &&
        !this.selectedList.some((selectedOption) => selectedOption.value == option.value)
      );
    });
  }

  applySelection() {
    this.modalController.dismiss({ selectedOptions: this.selectedList, type: this.type });
  }

  closeModal() {
    this.modalController.dismiss({});
  }
}
